import React, { useState, useContext, useEffect } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';
import axios from 'axios';
import { Lock } from 'react-feather';

import { FormTextInput } from '../Components/FormTextInput';
import { NotificationContext } from '../Context/NotificationContext';
import { useEnterKey } from '../Hooks/useEnterKey';
import { getFullHttpUrl } from '../firebase.config';
import { EAST1, EAST4 } from '../utility/enums';
import NewButton from '../NewComponents/NewButton';

import { Check, X } from 'react-feather';

import { AltAnimatedButton } from '../Components/AltAnimatedButton';
import TopBar from '../Components/TopBar';

import './Verify.css';

const Verify = ({ windowSize }) => {

  const { setColor } = useContext(TransitionContext);

  const { showNotification } = useContext(NotificationContext);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const [certificateID, setCertificateID] = useState('');
  const [password, setPassword] = useState('');

  const [authentic, setAuthentic] = useState('');

  const [downloadLinkName, setDownloadLinkName] = useState('');
  const [downloadLink, setDownloadLink] = useState('');

  const [submitButton, setSubmitButton] = useState('Verify');

  const handleLookup = async () => {
    setSubmitButton('Verifying...');

    axios({
      method:'post',
      url: getFullHttpUrl("verifyCredentials", EAST1),
      data: {
        certificateID: certificateID,
        password: password
      }
    })
      .then((response) => {
        setAuthentic(true);
        setDownloadLink(response.data.downloadLink);
        setDownloadLinkName(response.data.downloadLinkName);
        setSubmitButton('Verify');
      })
      .catch((error) => {
        setAuthentic(false);
        setDownloadLink('');
        setDownloadLinkName('');
        setSubmitButton('Verify');

        if (error.response.status === 500) {
          showNotification('Error', 'An error ocurred verifying the document. Try again. If it persists, please contact Support.', 'error');
        }
      });
    
  }

  const triggerLookup = () => {
    if (!(certificateID === "" || password === "")) {
      handleLookup();
    }
  }

  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  useEnterKey(() => triggerLookup());

  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>Document Verification</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>Verify the authenticity of the document provided to you and compare your copy against the original translated by eVerbary, LLC.</p>
         
        </div>
      </div>

      <div className=" bg-white rounded-4xl overflow-hidden shadow-sm py-12 my-4 max-md:rounded-xl">
        <div className="px-8 flex flex-col gap-4 justify-center items-center max-w-[1440px] mx-auto w-full">
        <h2 className='font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left'>Verify Your Document</h2>
        <p className="w-full mx-auto text-center text-xl">
        Enter your certificate ID and password to verify your document.
        </p>

        <div className="px-8 flex flex-col gap-4 justify-center items-center gap-[5px] flex-1 w-full max-w-[600px]">
          <FormTextInput placeholder="Certificate ID*" value={certificateID} onChange={setCertificateID} color='#666' />
          <FormTextInput placeholder="Password*" value={password} onChange={setPassword} color='#666' />
        </div>
        <NewButton text={submitButton} disabled={certificateID === "" || password === ""} onClick={handleLookup} />
        </div>
      </div>
      

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  );
}

export default Verify;